import { PALETTE } from './palette';

export const TEXT_COLORS = {
  PRIMARY: '#004d40',
  SECONDARY: '#216e54',
  SECONDARY_DARK: '#004d40',
  LINK: PALETTE.INFO.DEFAULT,
  SUCCESS: '#049404',
  WARNING: '#9f7200',
  DANGER: '#dc1f30',
  BLACK: '#171615',
  GREY: '#474443',
  DISABLED: '#84807e',
  WHITE: '#ffffff',
} as const;
